<template lang="html">
	<div class="col-12 grey-box text-center">
		<p style="margin-top: 15px;">
			<span class="material-icons">error_outline</span>
		</p>

		<h3>Vi kunne desværre ikke finde den side, du forsøger at komme ind på.</h3>

		<p>
			Indholdet er muligvis fjernet fra Odense Rundt.
		</p>
	</div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
